<template lang="pug">
  #video.hidden-xs.bg-fixed(v-youtube-video-background :data-url="youtubeUrl")
  #gif.bg-cover.visible-xs.relative(':style'='gifUrl | bgImage')
  section#philosophy.bg-white
    .sm-container.text-center
      h1.text-uppercase.invisible(v-scroll add-class="animated fadeInUp" remove-class="invisible") {{'HOME_PHILO_HEAD' | wordDict}}
        //- p.section_desc.invisible(v-scroll add-class="animated fadeInUp" remove-class="invisible") {{'HOME_PHILO_DESC' | wordDict}}

      .row.invisible(v-scroll add-class="animated fadeInUp" remove-class="invisible")
        .col-md-4
          .media
            .media-left
              img.bg-white(width="", height="48", src="./images/icons/Icon_Advise.png")
            .media-body
              h4.media-heading {{'PHILO_1_HEAD' | wordDict}}
              p {{'PHILO_1_DESC' | wordDict}}
        .col-md-4
          .media
            .media-left
              img.bg-white(width="", height="48", src="./images/icons/Icon_Invest_1.png")
            .media-body
              h4.media-heading {{'PHILO_2_HEAD' | wordDict}}
              p {{'PHILO_2_DESC' | wordDict}}
        .col-md-4
          .media
            .media-left
              img.bg-white(width="", height="48", src="./images/icons/Icon_Develop.png")
            .force-smaller-padding.media-body
              h4.media-heading {{'PHILO_3_HEAD' | wordDict}}
              p {{'PHILO_3_DESC' | wordDict}}

  section#cover.bg-filter.bg-cover

  section#numbers.bg-white.invisible(v-scroll add-class="animated fadeInUp" remove-class="invisible")
    .sm-container.text-center
      h1.text-uppercase {{'HOME_NUMBER_HEAD' | wordDict}}
      .row
        .grid
          p.h1 {{'NUMBER_1' | wordDict}}
          p {{'NUMBER_1_DESC' | wordDict}}
        .grid
          p.h1 {{'NUMBER_2' | wordDict}}
          p {{'NUMBER_2_DESC' | wordDict}}
        .grid.left-grid
          p.h1 {{'NUMBER_3' | wordDict}}
          p {{'NUMBER_3_DESC' | wordDict}}
        .grid
          p.h1 {{'NUMBER_4' | wordDict}}
          p {{'NUMBER_4_DESC' | wordDict}}
        .grid.left-grid
          p.h1 {{'NUMBER_5' | wordDict}}
          p {{'NUMBER_5_DESC' | wordDict}}
  section#cards.clearfix
    .half.col-md-3.no-padding-left-right(v-for="card in cards")
      .grid
        item(':link'="card.link"
              ':title'="card.title"
              ':full-text'="card.full"
              ':mobile-list'="false"
              ':image'="card.image")
  section#build-future
    .text-center
      h1.text-uppercase {{'BUILD_FUTURE_TITLE' | wordDict}}
      .mail-buttons
        a(target="_top", href="mailto:bp@aidgroup.co")
          img(src="./images/Hompage_future_entreprenuer.png")
          h4 {{'BUILD_FUTURE_DREAMS' | wordDict}}
        a(target="_top", href="mailto:career@aidgroup.co")
          img(src="./images/Hompage_future_talent.png")
          h4 {{'BUILD_FUTURE_JOBS' | wordDict}}
</template>

<script>
import Item from '../item.vue'
import VideoImageSlider from '../video_image_slider.vue'
import "animate.css/animate.min.css"
import axios from 'axios'
export default {
  data () {
    return {
      youtubeUrl: '',
      gifUrl: '',
      cards: [
        {
          link: '/portfolio?category=Technology',
          title: 'Technology',
          full: true,
          image: require('./images/technology.jpg')
        },
        {
          link: '/portfolio?category=N%2DS%20Media',
          title: 'Health-Tech',
          full: true,
          image: require('./images/home-healthtech.jpg')
        },
        {
          link: '/portfolio?category=E%26S',
          title: 'Lifestyle',
          full: true,
          image: require('./images/home-lifestyle.jpg')
        },
        {
          link: '/portfolio?category=F%26B',
          title: 'Finance',
          full: true,
          image: require('./images/home-finance.jpg')
        }
      ]
    }
  },
  created () {
    axios.get('/api/bannerlist/homepage')
          .then((response) => {
            const data = response.data
            let gifUrl = ''
            let url = ''
            if (_.has(data.result, 'youtube_video') && !_.isNull(data.result.youtube_video)) {
              url = data.result.youtube_video.url
            }
            if (_.has(data.result, 'gif_video') && !_.isNull(data.result.gif_video)) {
              gifUrl = data.result.gif_video.url
            }
            console.log(data)
            console.log(url)
            this.youtubeUrl = url
            this.gifUrl = gifUrl
          })
          .catch((error) => console.log(error))
  },
  computed: {},
  ready () {
  },
  attached () {},
  methods: {
  },
  components: {
    Item,
    VideoImageSlider
  }
}
</script>

<style lang="scss">
@import "global";
#cards {
  @media (max-width: $grid-float-breakpoint-max) {
    .half {
      width: 50%;
      float: left;
    }
  }
  .item {
    margin: 0;
  }
  .item-text {
    &.full-height {
      h5 {
        font-size: 14px;
        font-weight: bold;
        text-transform: uppercase;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
@import "global";
section:last-child {
  padding-top: 0;
  padding-bottom: 50px;
}
@media (max-width: $grid-float-breakpoint-max) {
  section {
    padding: 0;
  }
}
#video {
  position: relative;
}

#gif {
  width: 100%;
  padding-bottom: 100%;
  .overlay {
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background-color: rgba(0,0,0,0.6);
  }
  div {
    position: absolute;
    bottom: 0;
    padding: 16px;
    h1, p {
      color: #FFF;
    }
    h1 {
      letter-spacing: 1px;
      font-weight: bold;
      font-size: 16px;
    }
  }
}

#philosophy {
  .row {
    text-align: left;
    margin-top: 50px;
    p {
      color: $color-tab;
    }
  }
  img { margin-bottom: 10px; }
  @media (max-width: $grid-float-breakpoint-max) {
    h1 {
      font-size: 20px;
      font-weight: 700;
    }
    padding:0;
    .row {
      margin: 16px;
    }
    .col-md-4 {
      padding: 10px;
    }
    .media-body {
      padding-left: 16px;
    }

    .force-smaller-padding {
      padding-left: 4px;
    }
  }
}


#cover {
  background-image: url('./images/2-3_0_Homepage_HK.jpg');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top;
  background-attachment: fixed;
  @media (max-width: $grid-float-breakpoint-max) {
    background-attachment: inherit;
  }
  height: 0;
  padding-bottom: 500px;
  @media (max-width: $grid-float-breakpoint-max) {
    background-attachment: inherit;
    padding-bottom: 42.5%;
  }
}
#numbers {
  .sm-container {
    padding: 38px 15px;
  }
  .grid {
    padding-left: 10px;
    padding-right: 10px;
    width: 20%;
  }
  &:after {
    z-index: 0;
  }
  > div {
    position: relative;
    z-index: 10;
  }
  .row {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
  }

  @media (max-width: $grid-float-breakpoint-max) {
    h1 {
      font-size: 20px;
      letter-spacing: 1px;
    }
    .grid {
      &:first-child {
        width: 100%;
      }
      float: left;
      width: 50%;
    }
    .row {
      display: block;
    }
    p.h1 {
      font-weight: bold;
      font-size: 26px;
    }
  }
}

#build-future {
  img { max-width: 100%; }
  @media (max-width: $screen-xs-max) {
    padding-top: 24px;
    h1 {
      letter-spacing: 0;
      font-size: 20px;
    }
  }
  .mail-buttons {
    background-color: #eeeeee;
    @media (max-width: $screen-xs-max) {
      padding-top: 24px;
      padding-bottom: 24px;
      margin-top: 24px;
    }
    @media (min-width: $screen-sm) {
      padding-top: 40px;
      padding-bottom: 40px;
      margin-top: 40px;
    }
  }
  a {
    position: relative;
    display: inline-block;
    @media (max-width: $screen-xs-max) {
      width: 80%;
      & + a { margin-top: 24px; }
    }
    @media (min-width: $screen-sm) {
      width: 40%;
      margin-left: 3%;
      margin-right: 3%;
    }
    h4 {
      margin: 0;
      position: absolute;
      line-height: 0;
      left: 0;
      right: 0;
      @media (max-width: $screen-xs-max) {
        font-size: 16px;
        bottom: 12%;
        margin-top: 6px;
        margin-bottom: 6px;
      }
      @media (min-width: $screen-sm) {
        bottom: 16%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?777ad119